export default "__VITE_ASSET__412a17af__"